import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import EvaluationActions, { EvaluationRedux, EvaluationTypes } from '../Redux/EvaluationRedux'
import {notificationFail, notificationSuccess} from '../Redux/NotificationActions'

const evaluationCrudObservable = createCRUDObservable({
  mainRedux: EvaluationRedux,
  reduxPath: 'evaluation',
})

const getDimentionCatalogueEpic = (action$, store, { Api }) => (
  action$.ofType(EvaluationTypes.getDimentionCatalogueRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.evaluation.catDimentions()
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [EvaluationActions.getDimentionCatalogueError(response.error)]
          }
          return [
            EvaluationActions.getDimentionCatalogueSuccess(response.data.data),
          ]
        })
    ))
)

const getResultsCatalogueEpic = (action$, store, { Api }) => (
  action$.ofType(EvaluationTypes.getResultsCatalogueRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.evaluation.catResults()
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [EvaluationActions.getResultsCatalogueError(response.error)]
          }
          return [
            EvaluationActions.getResultsCatalogueSuccess(response.data.data),
          ]
        })
    ))
)

const getCyclesCatalogueEpic = (action$, store, { Api }) => (
  action$.ofType(EvaluationTypes.getCyclesCatalogueRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.evaluation.catCycles()
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [EvaluationActions.getCyclesCatalogueError(response.error)]
          }
          return [
            EvaluationActions.getCyclesCatalogueSuccess(response.data.data),
          ]
        })
    ))
)

const getStudyProgramsCatalogueEpic = (action$, store, { Api }) => (

  action$.ofType(EvaluationTypes.getStudyProgramsCatalogueRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.evaluation.catStudyPrograms()
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [EvaluationActions.getStudyProgramsCatalogueError(response.error)]
          }
          return [EvaluationActions.getStudyProgramsCatalogueSuccess(response.data.data),
          ]
        })
    ))
)
const getDimentionByStudyProgramEpic = (action$, store, { Api }) => (
  action$.ofType(EvaluationTypes.getDimentionByStudyProgramRequest)
    .mergeMap(({ params }) => (
      Observable
        .fromPromise(Api.evaluation.getDimentionByStudyProgram(params.studentId, params.studyProgramId)
          .then(response => response)
          .catch(err => err))
    ))
    .flatMap((response) => {
      const { status } = response
      if (!(status >= 200 && status < 300)) {
        return [EvaluationActions.getDimentionByStudyProgramError(response.error )]
      }
      return [EvaluationActions.getDimentionByStudyProgramSuccess(response.data.data)]
    })
)

const patchEvaluationEpic = (action$, store, { Api }) => (
  action$.ofType(EvaluationTypes.patchEvaluationRequest)
    .mergeMap(({ payload }) => (
      Observable
        .fromPromise(Api.evaluation.patch(payload)
          .then(response => response)
          .catch(err => err))
    )).flatMap((response) => {
      const { status } = response
      if (!(status >= 200 && status < 300)) {
        return [EvaluationActions.patchEvaluationError(response.error)]
      }
      return [EvaluationActions.patchEvaluationSuccess(response.data.data)]
    })
)

const createEvaluationEpic = (action$, store, { Api }) => (
  action$.ofType(EvaluationTypes.createEvaluationRequest)
    .mergeMap(({ payload }) => (
      Observable
        .fromPromise(Api.evaluation.create(payload)
          .then(response => response)
          .catch(err => err))
    ))
    .flatMap((response) => {
      const { status } = response
      if (!(status >= 200 && status < 300)) {
        return [EvaluationActions.createEvaluationError(response.error)]
      }
      return [EvaluationActions.createEvaluationSuccess(response.data.data)]
    })
)

const deleteEvaluationEpic = (action$, store, { Api }) => (
  action$.ofType(EvaluationTypes.deleteEvaluationRequest)
    .mergeMap(({ payload }) => (
      Observable
        .fromPromise(Api.evaluation.delete(payload)
          .then(response => response)
          .catch(err => err))
    ))
    .flatMap((response) => {
      const { status } = response
      if (!(status >= 200 && status < 300)) {
        return [EvaluationActions.deleteEvaluationError(response.error)]
      }
      return [EvaluationActions.deleteEvaluationSuccess()]
    })
)

const generatePDFEpic = (action$, store, { Api }) => (
  action$.ofType(EvaluationTypes.generatePDFRequest)
    .mergeMap(({ payload }) => (
      Observable
        .fromPromise(Api.evaluation.generatePDF(payload)
          .then(response => response)
          .catch(err => err))
    ))
    .flatMap((response) => {
      const { status } = response
      if (!(status >= 200 && status < 300)) {
        return [EvaluationActions.generatePDFError(response.error)]
      }

      return [EvaluationActions.generatePDFSuccess(response.data.data)]
    })
)

export const evaluationObservers = Object.assign({}, evaluationCrudObservable.observers, {})

export const evaluationEpic = combineEpics(
  evaluationCrudObservable.epic,
  getDimentionCatalogueEpic,
  getResultsCatalogueEpic,
  getCyclesCatalogueEpic,
  getStudyProgramsCatalogueEpic,
  getDimentionByStudyProgramEpic,
  patchEvaluationEpic,
  createEvaluationEpic,
  deleteEvaluationEpic,
  generatePDFEpic,
)


// WEBPACK FOOTER //
// ./src/Data/Observables/EvaluationObservable.js